import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    HasOnError,
} from "@insite/client-framework/HandlerCreator";
import { getDivisionCollection, DivisionCollectionModel } from "@tCentro/Services/CENAdminDivisionService";

export interface GetDivisionCollectionParameter extends HasOnSuccess<DivisionCollectionModel>, HasOnError<string> {}

type HandlerType = ApiHandler<GetDivisionCollectionParameter, { apiResult: DivisionCollectionModel }>;
export interface GetDivisionCollectionParameter extends HasOnSuccess<DivisionCollectionModel>, HasOnError<string> {
    page?: number;
    pageSize?: number;
    query?: string;
}

export const GetDivisionCollection: HandlerType = async props => {
    try {
        const result = await getDivisionCollection(props.parameter.page, props.parameter.pageSize, props.parameter.query);
        if (props.parameter.onSuccess) {
            props.parameter.onSuccess(result);
        }
    } catch (error: any) {
        if (props.parameter.onError) {
            props.parameter.onError(error?.message ?? "Failed to load divisions");
        }
    }
};

export const chain = [GetDivisionCollection];
const getDivisionCollectionData = createHandlerChainRunner(chain, "getDivisionCollectionData");
export default getDivisionCollectionData;
